import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CallPOSTAPI } from "../helper/Constants";

function Register() {
  const logoUrl = `${process.env.PUBLIC_URL || ""}/callmafia-logo.png`;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateForm = () => {
    const errors = {};

    if (!firstName.trim()) {
      errors.firstName = "First Name is required";
    }

    if (!lastName.trim()) {
      errors.lastName = "Last Name is required";
    }

    if (!email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email address is invalid";
    }

    if (!password.trim()) {
      errors.password = "Password is required";
    }

    if (!rePassword.trim()) {
      errors.rePassword = "Please re-enter your password";
    } else if (password !== rePassword) {
      errors.rePassword = "Passwords do not match";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    try {
      setLoading(true);

      const response = await CallPOSTAPI(
        "api/admin-create",
        {
          first_name: firstName,
          last_name: lastName,
          email: email,
          password: password,
          repassword: rePassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        toast.success("Register Successful");
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong, please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      firstName: "",
    }));
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      lastName: "",
    }));
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      email: "",
    }));
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      password: "",
    }));
  };

  const handleRePasswordChange = (e) => {
    setRePassword(e.target.value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      rePassword: "",
    }));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-stone-50 to-rose-100 dark:from-black dark:via-[#120607] dark:to-[#22090d]">
      <main className="flex min-h-screen items-center justify-center px-4 py-8">
        <div className="w-full max-w-5xl">
          <div className="grid overflow-hidden rounded-3xl border border-red-100 bg-white shadow-[0_24px_60px_rgba(127,29,29,0.16)] dark:border-red-950/40 dark:bg-[#100607] dark:shadow-[0_28px_70px_rgba(127,29,29,0.28)] lg:grid-cols-[0.95fr_1.05fr]">
            <div className="hidden bg-[radial-gradient(circle_at_top,_rgba(220,38,38,0.16),_transparent_28%),linear-gradient(180deg,_#120405_0%,_#090304_100%)] p-10 text-white lg:flex lg:flex-col lg:justify-between xl:p-12">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.3em] text-red-200/70">
                  CallMafia Admin Register
                </p>
                <div className="mt-8 flex items-center justify-center">
                  <div className="overflow-hidden rounded-full border border-red-700/60 bg-black shadow-[0_24px_60px_rgba(127,29,29,0.38)]">
                    <img
                      src={logoUrl}
                      alt="CallMafia logo"
                      className="h-64 w-64 object-cover"
                    />
                  </div>
                </div>
                <h2 className="mt-10 text-4xl font-bold tracking-tight text-white">
                  Admin registration now matches the same branded login style.
                </h2>
                <p className="mt-5 text-base leading-8 text-zinc-300">
                  Left-side logo, dark red palette, and a consistent auth experience across admin pages.
                </p>
              </div>

              <div className="space-y-3">
                <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-4 text-sm text-white/72">
                  Same premium admin branding
                </div>
                <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-4 text-sm text-white/72">
                  Large logo on desktop left panel
                </div>
              </div>
            </div>

            <div className="px-6 py-6 sm:px-8">
              <div className="mb-6 text-center">
                <div className="mx-auto mb-5 overflow-hidden rounded-[22px] border border-red-200 bg-white shadow-[0_12px_30px_rgba(127,29,29,0.14)] dark:border-red-900/40 dark:bg-black lg:hidden">
                  <img
                    src={logoUrl}
                    alt="CallMafia logo"
                    className="h-20 w-20 object-cover"
                  />
                </div>
                <p className="mb-2 text-xs font-semibold uppercase tracking-[0.3em] text-red-600 dark:text-red-300">
                  Admin Registration
                </p>
                <h1 className="mb-2 text-3xl font-bold text-gray-900 dark:text-white">
                  Create an Account
                </h1>
                <p className="text-sm text-gray-600 dark:text-zinc-300">
                  Enter your personal details to create the admin account
                </p>
              </div>

              <form onSubmit={handleSubmit} noValidate className="space-y-5">
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                    <label htmlFor="firstName" className="mb-2 block text-sm font-medium text-gray-700 dark:text-zinc-200">
                      First Name
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      value={firstName}
                      onChange={handleFirstNameChange}
                      className={`w-full rounded-xl border px-4 py-3 text-gray-900 transition-colors focus:border-transparent focus:outline-none focus:ring-2 dark:bg-black/40 dark:text-white ${
                        errors.firstName
                          ? "border-red-500 bg-red-50/40 focus:ring-red-500"
                          : "border-red-100 bg-red-50/40 focus:ring-red-500 dark:border-red-950/40"
                      }`}
                      id="firstName"
                      required
                    />
                    {errors.firstName && <p className="mt-1 text-xs text-red-600 dark:text-red-400">{errors.firstName}</p>}
                  </div>

                  <div>
                    <label htmlFor="lastName" className="mb-2 block text-sm font-medium text-gray-700 dark:text-zinc-200">
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      value={lastName}
                      onChange={handleLastNameChange}
                      className={`w-full rounded-xl border px-4 py-3 text-gray-900 transition-colors focus:border-transparent focus:outline-none focus:ring-2 dark:bg-black/40 dark:text-white ${
                        errors.lastName
                          ? "border-red-500 bg-red-50/40 focus:ring-red-500"
                          : "border-red-100 bg-red-50/40 focus:ring-red-500 dark:border-red-950/40"
                      }`}
                      id="lastName"
                      required
                    />
                    {errors.lastName && <p className="mt-1 text-xs text-red-600 dark:text-red-400">{errors.lastName}</p>}
                  </div>
                </div>

                <div>
                  <label htmlFor="yourEmail" className="mb-2 block text-sm font-medium text-gray-700 dark:text-zinc-200">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleEmailChange}
                    className={`w-full rounded-xl border px-4 py-3 text-gray-900 transition-colors focus:border-transparent focus:outline-none focus:ring-2 dark:bg-black/40 dark:text-white ${
                      errors.email
                        ? "border-red-500 bg-red-50/40 focus:ring-red-500"
                        : "border-red-100 bg-red-50/40 focus:ring-red-500 dark:border-red-950/40"
                    }`}
                    id="yourEmail"
                    required
                  />
                  {errors.email && <p className="mt-1 text-xs text-red-600 dark:text-red-400">{errors.email}</p>}
                </div>

                <div>
                  <label htmlFor="yourPassword" className="mb-2 block text-sm font-medium text-gray-700 dark:text-zinc-200">
                    Password
                  </label>
                  <input
                    type="password"
                    name="password"
                    value={password}
                    onChange={handlePasswordChange}
                    className={`w-full rounded-xl border px-4 py-3 text-gray-900 transition-colors focus:border-transparent focus:outline-none focus:ring-2 dark:bg-black/40 dark:text-white ${
                      errors.password
                        ? "border-red-500 bg-red-50/40 focus:ring-red-500"
                        : "border-red-100 bg-red-50/40 focus:ring-red-500 dark:border-red-950/40"
                    }`}
                    id="yourPassword"
                    required
                  />
                  {errors.password && <p className="mt-1 text-xs text-red-600 dark:text-red-400">{errors.password}</p>}
                </div>

                <div>
                  <label htmlFor="rePassword" className="mb-2 block text-sm font-medium text-gray-700 dark:text-zinc-200">
                    Re-enter Password
                  </label>
                  <input
                    type="password"
                    name="rePassword"
                    value={rePassword}
                    onChange={handleRePasswordChange}
                    className={`w-full rounded-xl border px-4 py-3 text-gray-900 transition-colors focus:border-transparent focus:outline-none focus:ring-2 dark:bg-black/40 dark:text-white ${
                      errors.rePassword
                        ? "border-red-500 bg-red-50/40 focus:ring-red-500"
                        : "border-red-100 bg-red-50/40 focus:ring-red-500 dark:border-red-950/40"
                    }`}
                    id="rePassword"
                    required
                  />
                  {errors.rePassword && <p className="mt-1 text-xs text-red-600 dark:text-red-400">{errors.rePassword}</p>}
                </div>

                <label className="flex items-start gap-3 text-sm text-gray-700 dark:text-zinc-300">
                  <input
                    className="mt-1 h-4 w-4 rounded border-red-300 text-red-600 focus:ring-red-500"
                    name="terms"
                    type="checkbox"
                    defaultValue
                    id="acceptTerms"
                    required
                  />
                  <span>
                    I agree and accept the <a href="#" className="text-red-700 hover:underline dark:text-red-300">terms and conditions</a>
                  </span>
                </label>

                <button
                  className="flex w-full items-center justify-center rounded-xl bg-gradient-to-r from-red-700 via-red-600 to-rose-500 px-4 py-3 font-medium text-white shadow-[0_18px_30px_rgba(127,29,29,0.22)] transition-colors duration-200 hover:from-red-600 hover:via-red-500 hover:to-rose-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:from-red-300 disabled:via-red-300 disabled:to-rose-300"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Create Account"}
                </button>

                <p className="text-center text-sm text-gray-600 dark:text-zinc-300">
                  Already have an account?{" "}
                  <Link to="/" className="font-medium text-red-700 hover:underline dark:text-red-300">
                    Log in
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Register;
